import { useEffect } from 'react';
import s from './ui.module.scss';

/**
 * Le bandeau d'erreur.
 *
 * Toutes les erreurs du jeu viennent du serveur et sont deja redigees en
 * francais lisible (« mise hors de votre fourchette », « salon complet »). On
 * ne les traduit pas et on ne les habille pas : les reformuler ici creerait
 * un second vocabulaire a maintenir.
 *
 * `role="alert"` le fait annoncer immediatement ; la disparition automatique
 * evite qu'un refus de mise reste a l'ecran pendant la manche suivante.
 */
export interface BannerProps {
  message: string;
  onDismiss: () => void;
}

const LINGER_MS = 5000;

export function Banner({ message, onDismiss }: BannerProps) {
  useEffect(() => {
    const timer = window.setTimeout(onDismiss, LINGER_MS);
    return () => window.clearTimeout(timer);
  }, [message, onDismiss]);

  return (
    <div className={s.banner} role="alert">
      <span className={s.bannerMark} aria-hidden="true">
        !
      </span>
      <span className={s.bannerText}>{message}</span>
      <button type="button" className={s.bannerClose} onClick={onDismiss} aria-label="Fermer">
        x
      </button>
    </div>
  );
}
